const Pdf = "/images/files/pdf.svg";
export const FILES_ICON = {
  pdf: Pdf,
};
